import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Image from "next/image";
import { useAppContext } from "../../../_context";
import LoginForm from "../../../components/Pages/Login/Login/LoginForm";

function Login() {
  const [{ tx }] = useAppContext();
  return (
    <Container>
      <Row>
        <Col md={7} lg={7} className="d-none d-lg-block">
          <div className="image-with-mirrored-color">
            <Image
              src="/img/cancelation/img_login.jpg"
              width={728}
              height={736}
              unoptimized={true}
            />
            <div className="position-absolute bottom-0 left-0 m-5 w-50 w-sm-100 text-white">
              <h1>RacketPal</h1>
              <p className="mb-0 fw-bold">
                {
                  tx[
                    "Find local racket sports pals in minutes and start playing today"
                  ]
                }
              </p>
            </div>
          </div>
        </Col>
        <Col sm={12} md={12} lg={5}>
          <LoginForm />
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
